import { GetCompaniesByFilterUsecase } from "../../../usecases/get-companies-by-filter.usecase";
import { Validators } from "../../../utils/validators/Validators";
import { ESocialXmlReaderService } from "./ESocialXmlReaderService";
var JSZip = require("jszip");

export class ESocialImportService {
    isDuplicateCompanies = false;
    constructor({ ESocialHttpGateway, Company } = {}) {
        this.ESocialHttpGateway = ESocialHttpGateway;
        this.Company = Company;
    }

    async exec({ files, company, accounting, user, isCreateCompany = false }) {
        try {
            const responses = [];
            const stringFiles = await this._convertFilesESocial({
                files
            });

            if (isCreateCompany) {
                const isEsocialValid = await Validators.isValidByTypeFile(
                    stringFiles,
                    "eSocial"
                );
                if (!isEsocialValid)
                    return {
                        eSocialIsNotValid: true
                    };

                const xmlReaderService = new ESocialXmlReaderService();
                let companyEvents = {
                    document: null,
                    files: []
                };

                for (const stringFile of stringFiles) {
                    const eSocialEventData = await xmlReaderService.transformXmlToJs(
                        stringFile.content,
                        stringFile.fileName
                    );

                    const companyDocument =
                        eSocialEventData.eventData.infoCS?.[0].ideEstab?.[0]
                            .nrInsc[0] ||
                        eSocialEventData.eventData.infoCp?.[0].ideEstabLot?.[0]
                            .nrInsc[0] ||
                        eSocialEventData?.eventData?.infoEstab?.[0]
                            .inclusao?.[0]?.ideEstab?.[0]?.nrInsc?.[0];

                    if (companyDocument) {
                        companyEvents.document = companyDocument;
                    }

                    companyEvents.files.push(stringFile);
                }

                const companieseSocial = await this._managerCompanies(
                    accounting.props._id,
                    [companyEvents]
                );

                if (companieseSocial[0]?.companiesHasCreated) {
                    return companieseSocial;
                }

                for (let companyeSocial of companieseSocial) {
                    const filesChunk = this._slicer(
                        companyeSocial.eSocial,
                        200
                    );
                    for (const chunk of filesChunk) {
                        console.info("[eSocial] Importando dados");
                        await this.ESocialHttpGateway.importFiles({
                            accountingId: accounting.props._id,
                            companyId: companyeSocial.companyId,
                            userId: user.props._id,
                            files: chunk
                        });
                    }

                    console.info("[eSocial] Dados importado");
                    return companieseSocial;
                }
            } else {
                const filesChunk = this._slicer(stringFiles, 200);

                for (const chunk of filesChunk) {
                    const response = await this.ESocialHttpGateway.importFiles({
                        accountingId: accounting.props._id,
                        companyId: company.props._id,
                        userId: user.props._id,
                        files: chunk
                    });

                    responses.push(response);
                }
            }

            return responses;
        } catch (error) {
            console.log("error", error);
            return error;
        }
    }

    async _managerCompanies(accountingId, documents) {
        const uniqDocuments = [
            ...new Set(
                documents.filter((d) => d.document).map((d) => d.document)
            )
        ];

        const getCompaniesByFilterUsecase = new GetCompaniesByFilterUsecase();
        const companiesExists = await getCompaniesByFilterUsecase.execute({
            accountingId,
            filter: {
                documents: uniqDocuments
            }
        });

        const documentNotExists = uniqDocuments.filter(
            (i) => !companiesExists.map((c) => c.document).includes(i)
        );

        if (companiesExists.length && documentNotExists.length) {
            this.isDuplicateCompanies = true;
        }

        const response = [];

        if (documentNotExists.length) {
            const companies = documentNotExists.map((c) => ({
                document: c,
                status: "ATIVO"
            }));

            const companiesCreated = await this.Company.createNewCompanies({
                accountingId,
                companies
            });

            companiesCreated.forEach((c) => {
                const companieseSocial = documents.filter(
                    (s) => s.document === c.document
                );

                const filesEsocial = companieseSocial.map((c) => c.files);

                response.push({
                    companyId: c._id,
                    eSocial: filesEsocial.flat()
                });
            });
        } else {
            response.push({ companiesHasCreated: true });
        }

        return response;
    }

    hasDuplicateImportCompanies() {
        if (this.isDuplicateCompanies) {
            this.isDuplicateCompanies = false;
            return true;
        } else return false;
    }

    _slicer(files, maxByChunk) {
        return files.reduce((chunk, file, index) => {
            const group = Math.floor(index / maxByChunk);
            chunk[group] = [...(chunk[group] || []), file];
            return chunk;
        }, []);
    }

    async _convertFilesESocial({ files }) {
        const filesToString = [];

        const zipFiles = files.filter((file) => file.type.includes("zip"));
        const xmlFiles = files.filter((file) => file.type === "text/xml");

        const zipResult = await this._readZipFiles({ files: zipFiles });
        filesToString.push(...zipResult);

        const xmlResult = await this._readXmlFiles({ files: xmlFiles });
        filesToString.push(...xmlResult);

        return filesToString;
    }

    async _readZipFiles({ files }) {
        const filesToString = [];

        for (const zipFile of files) {
            const zip = await JSZip.loadAsync(zipFile);

            for (const [fileName, fileContent] of Object.entries(zip.files)) {
                if (!fileContent.dir && fileName.includes("xml")) {
                    const content = await fileContent.async("string");

                    filesToString.push({
                        fileName: fileName,
                        content
                    });
                }
            }
        }

        return filesToString;
    }

    _readXmlFiles({ files }) {
        return new Promise((resolve, reject) => {
            const filesToString = [];

            if (files.length > 0) {
                for (const xmlFile of files) {
                    const reader = new FileReader();

                    reader.onload = () => {
                        const fileContent = reader.result;

                        filesToString.push({
                            fileName: xmlFile.name,
                            content: fileContent
                        });

                        if (files.length === filesToString.length)
                            resolve(filesToString);
                    };
                    reader.readAsText(xmlFile);
                }
            } else {
                resolve([]);
            }
        });
    }
}
